import React from 'react';
import CreateUserState from './createUserState/CreateUserState';
import Form from './components/Form/Form';
import ModalWindows from './components/ModalWindows/ModalWindows';

const CreateUserPage: React.FC = () => {
	return (
		<CreateUserState>
			<Form />
			<ModalWindows />
		</CreateUserState>
	);
};

export default CreateUserPage;
